Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InboxContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.InboxContent(socialContent)
    content.set({ possibleTags: allTags })
    if content.isEmail() then content.standarizeEmail()
    return content

  canHandle: (socialContent) ->
    return socialContent.group_type == 'inbox' and socialContent.data and socialContent.data.content
